export const SANITIZE_CONFIG = {
  CHAT: {
    ALLOWED_TAGS: ['p', 'br', 'a', 'strong', 'em', 's', 'blockquote', 'ul', 'ol', 'li'] as const,
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'id'] as const,
  },
};
